import { get } from "core-web/libs/GrebbCommerceAPI/util";
import { getModel } from "core-web/state";

export default async () => {
    const applicationId = getModel("application").applicationId;

    return await get("/frontend/user/favorite-product", { application_id: applicationId });
};
